<template>
	<v-dialog v-model="visible" :max-width="maxWidth" persistent>
		<v-card color="#FFFFFF" @click.native="close_selection += 1">
			<v-system-bar :color="color" height="12"></v-system-bar>
			<v-alert v-if="error_msg.length !== 0" class="my-1 rounded-b-0" type="error" dense>
				{{ error_msg }}
			</v-alert>
			<div class="pa-4">
				<v-row class="ma-0">
					<span class="title-sytle">Production</span>
				</v-row>
				<ProgressLinear v-if="loading" class="mx-0 mt-2 mb-4"/>
				<v-row v-else class="ma-0">
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-0 pr-2'">
						<div class="item-style">Phase</div>
						<v-select
							v-model="phase_local"
							:color="color"
							:menu-props="{ bottom: true, offsetY: true}"
							:loading="phase_loading"
							:items="phase_items"
							:disabled="productionId !== 0 || !productionEdit"
							item-value="id"
							item-text="desc"
							item-color="media"
							background-color="#FAFAFA"
							outlined
							dense
							hide-details
							return-object
						>
						</v-select>
						<div class="item-style mt-3">Kind</div>
						<KindTreeSelection
							ref="kind"
							:color="color"
							:bgColor="'#FAFAFA'"
							:kindParams="kindParams"
							:kindSelected="kind_local"
							:closeSelection="close_selection"
							:isWidthAuto="true"
							:disabled="!productionEdit"
							@kind-selected="onKindChange($event)"
						/>
						<div class="item-style mt-3">Amount</div>
						<v-text-field
							:value="numberFormat(amount)"
							class="field-in-cell"
							:color="color"
							:disabled="!productionEdit"
							outlined
							dense
							hide-details
							prefix="$"
							background-color="#FAFAFA"
							@change="onAmountChange($event)"
						></v-text-field>
						<div class="item-style mt-3">Start date to End date</div>
						<DateMulti
							:color="color"
							:background="'#FAFAFA'"
							:suggestionText="''"
							:hideDetails="true"
							:disabled="!productionEdit"
							:dateStartInit="date_start"
							:dateEndInit="date_end"
							@dateRange="onDateChange($event)"
						/>
					</v-col>
					<v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 6" :class="$vuetify.breakpoint.xsOnly ? 'px-0':'pl-2 pr-0'">
						<div class="item-style">Description</div>
						<v-textarea
							:color="color"
							:disabled="!productionEdit"
							outlined
							v-model="desc"
							hide-details
							clearable
							height="184"
							background-color="#FAFAFA"
						></v-textarea>
						<v-checkbox
							class="mt-6"
							v-model="nobill"
							:color="color"
							:disabled="!productionEdit"
							label="Do not bill"
							hide-details
							dense
						></v-checkbox>
					</v-col>
				</v-row>
				<v-row class="mt-4 mb-0 mx-0" justify="center">
					<v-btn outlined class="text-capitalize mr-2" color="rgba(25, 42, 62, 0.7)" max-height="36" @click="$emit('close')">Cancel</v-btn>
					<v-btn class="text-capitalize white--text" :color="color" elevation="0" :disabled="!buttonActive || !productionEdit" @click="onSave()">
						<span v-if="productionId !== 0">Save changes</span>
						<span v-else>Add Production</span>
					</v-btn>
				</v-row>
			</div>
		</v-card>
	</v-dialog>
</template>
<script>
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import KindTreeSelection from "@/components/kinds/kind_tree_selection.vue";
import DateMulti from "@/components/date/date_multi.vue";
import moment from "moment-timezone";

export default {
	name: 'MediaPlanProductionDialog',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		maxWidth: {
			type: Number,
			default: 600
		},
		color: {
			type: String,
			default: '#605AF6'
		},
		jobId: {
			type: Number,
			default: 0
		},
		kindParams: {
			type: Object,
			default: null
		},
		productionId: {
			type: Number,
			default: 0
		},
		productionEdit: {
			type: Boolean,
			default: true
		}
	},
	components: {
		ProgressLinear,
		KindTreeSelection,
		DateMulti,
	},
	data() {
		return {
			error_msg: '',
			close_selection: 0,
			loading: false,

			phase_loading: false,
			phase_local: this.phase,
			phase_items: [],

			kind_local: null,

			date_start: moment().format('YYYY-MM-DD'),
			date_end: moment().format('YYYY-MM-DD'),

			amount: '0.00',
			desc: '',
			nobill: false,

			order: 0,
			status: 1,
			do_print: true
		}
	},
	created() {
		this.getPhaseList();

		if (this.productionId !== 0) {
			this.getProduction(this.productionId);
		}
	},
	computed: {
		buttonActive() {
			let active = false;

			if (this.kind_local && this.kind_local.id !== 0 && Number(this.amount) > 0 && this.desc.length !== 0) {
				if (this.date_start && this.date_start.length !== 0 && this.date_end && this.date_end.length !== 0 && this.date_start <= this.date_end) {
					active = true;
				}
			}
			
			return active;
		}
	},
	methods: {
		getPhaseList() {
			this.phase_loading = true;

			const url = `/api/jobs/${this.jobId}/phases`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_items = data.map((d, index) => { 
							const obj = {
								id: d.id,
								desc: d.display_name,
								order: index
							};

							return obj;
						});

						if (this.productionId === 0) {
							this.phase_local = this.phase_items[0];
						}
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.phase_loading = false;
				});
		},
		getProduction(prod_id) {
			this.loading = true;

			const url = `/api/media/media_planning/production/${prod_id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const {status, data, reason } = val.data;
					if (status == "OK") {
						this.phase_local = data.phase;

						const kind = data.kind;
						kind['display_name'] = data.kind.name;
						this.kind_local = kind;

						this.amount = Number(data.amount_div).toFixed(2);
						this.date_start = moment(data.prod_start, 'YYYYMMDD').format('YYYY-MM-DD');
						this.date_end = moment(data.prod_end, 'YYYYMMDD').format('YYYY-MM-DD');
						this.desc = data.description;

						this.order = data.order;
						this.status = data.status;
						this.do_print = data.do_print;
						this.nobill = data.do_not_bill;
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		numberFormat(num_str) {
			let number_format = '';

			if (typeof(num_str) === 'string' && num_str.length !== 0) {
				number_format = new Intl.NumberFormat('en-US', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				}).format(num_str);
			}
			return number_format;
		},
		onKindChange(kind) {
			if (kind && kind.id !== 0) {
				this.kind_local = kind;
			}

			if (kind === null) {
				this.kind_local = { id: 0, display_name: '' };
			}
		},
		onAmountChange(amount_str) {
			let num = '0.00';

			let number_parse = '';
			if (amount_str.includes(',')) {
				const numberString = amount_str.replace(/[^0-9.-]+/g, "");
				number_parse = Number(numberString).toFixed(2);
			} else {
				number_parse = Number(amount_str).toFixed(2);
			}

			if (isNaN(number_parse)) {
				num = '0.00'
			} else {
				num = Number(number_parse) < 0 ? Number(Math.abs(Number(number_parse))).toFixed(2) : Number(number_parse).toFixed(2);
			}

			this.amount = num;
		},
		onDateChange(date_arr) {
			if (date_arr.length === 0) {
				this.date_start = '';
				this.date_end = '';
			}

			if (date_arr.length === 2) {
				this.date_start = date_arr[0];
				this.date_end = date_arr[1];
			}
		},
		onSave() {
			const params_obj = {
				phase_id: this.phase_local.id,
				kind_id: this.kind_local.id,
				prod_start: this.date_start,
				prod_end: this.date_end,
				description: this.desc,
				amount_div: Number(this.amount),
				status: this.status,
				do_print: this.do_print,
				do_not_bill: this.nobill,
				order: this.order
			};

			if (this.productionId === 0) {
				this._onCreateProduction(params_obj);
			} else {
				this._onUpdateProduction(params_obj)
			}
		},
		_onCreateProduction(params_obj) {
			const url = '/api/media/media_planning/production';

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		_onUpdateProduction(params_obj) {
			const url = `/api/media/media_planning/production/${this.productionId}`;

			axios
				.put(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.$emit('close', true)
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
		}
	}
}
</script>
<style lang="scss" scoped>
.title-sytle {
  font-family: Roboto;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #605AF6;
}
.item-style {
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #37495F;
}
::v-deep {
	.field-in-cell input {
		padding-right: 4px;
		text-align: end;
	}
}
</style>